(function () {
  var ROOT_MARGIN = '250px 0px';
  var SELECTOR = '[data-lazy-media]';

  function parseSources(raw) {
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  function hydrateVideo(video) {
    if (video.dataset.lazyLoaded === 'true') return;
    video.dataset.lazyLoaded = 'true';

    parseSources(video.dataset.lazySources).forEach(function (source) {
      if (!source.src) return;
      var node = document.createElement('source');
      node.src = source.src;
      if (source.type) node.type = source.type;
      video.appendChild(node);
    });

    video.load();

    if (video.dataset.lazyAutoplay === 'true') {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  }

  function hydrateIframe(iframe) {
    if (iframe.dataset.lazyLoaded === 'true') return;
    var src = iframe.dataset.lazySrc;
    if (!src) return;
    iframe.dataset.lazyLoaded = 'true';
    iframe.src = src;
  }

  function upgradeNativeVideos() {
    document.querySelectorAll('video.lazy-media-video--upgrade').forEach(function (video) {
      if (video.dataset.lazyLoaded === 'true') return;
      var sources = video.querySelectorAll('source');
      if (!sources.length) return;

      var payload = [];
      sources.forEach(function (source) {
        payload.push({ src: source.src, type: source.type || '' });
        source.remove();
      });

      video.preload = 'none';
      video.dataset.lazyMedia = 'video';
      video.dataset.lazySources = JSON.stringify(payload);
      if (video.hasAttribute('autoplay')) {
        video.removeAttribute('autoplay');
        video.dataset.lazyAutoplay = 'true';
      }
    });
  }

  function observeLazyMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        if (el.dataset.lazyMedia === 'video') hydrateVideo(el);
        if (el.dataset.lazyMedia === 'iframe') hydrateIframe(el);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.dataset.lazyMedia === 'video') hydrateVideo(el);
          if (el.dataset.lazyMedia === 'iframe') hydrateIframe(el);
          observer.unobserve(el);
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0.01 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init(root) {
    upgradeNativeVideos();
    observeLazyMedia(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('theme:lazy-media', function (event) {
    init(event.detail && event.detail.root ? event.detail.root : document);
  });
})();
